module.exports = __webpack_public_path__ + "img/image (1).afdc6145.jpg";